import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const FRANCILLY_PREVIOUS_IMAGE = '/assets/photos/testimonials/francielly-cork.png';
const FRANCILLY_GRAMMAR_IMAGE = '/assets/photos/site-updates/grammar-lesson.webp';
// Cíntia's photo was uploaded to the backend's local disk (not Cloudinary) and
// lost on a Render redeploy — the stored imageUrl 404s (2026-08-31). Swapping
// it here for a real photo checked into the repo needs no database write and
// ships on the next deploy. Matched on the exact stale URL (not just the
// slug) so a real admin-set replacement later isn't silently overridden.
const CINTIA_BROKEN_IMAGE = 'https://frankly-app-8cca.onrender.com/uploads/0f7cdd9a-ff08-4390-9aa0-218d369e16ec.jpeg';
const CINTIA_REPLACEMENT_IMAGE = '/assets/photos/testimonials/testemonials-cintia.jpeg';

const normalizeTestimonial = (testimonial) => {
  if (!testimonial || typeof testimonial !== 'object') return testimonial;
  if (testimonial.slug === 'francielly' && testimonial.imageUrl === FRANCILLY_PREVIOUS_IMAGE) {
    return {
      ...testimonial,
      imageUrl: FRANCILLY_GRAMMAR_IMAGE,
      imageAlt: 'Grammar lesson with Cida and two students',
    };
  }
  if (testimonial.slug === 'cintia-ranusia' && testimonial.imageUrl === CINTIA_BROKEN_IMAGE) {
    return {
      ...testimonial,
      imageUrl: CINTIA_REPLACEMENT_IMAGE,
    };
  }
  return testimonial;
};

const unwrap = (response) => {
  const data = response.data?.data || response.data || [];
  return Array.isArray(data) ? data.map(normalizeTestimonial) : normalizeTestimonial(data);
};

export const getFeaturedTestimonials = async (limit = 4, lang = 'en') => {
  const response = await axios.get(`${API_URL}/api/testimonials/featured`, { params: { limit, lang } });
  return unwrap(response);
};

export const getTestimonials = async (lang = 'en') => {
  const response = await axios.get(`${API_URL}/api/testimonials`, { params: { lang } });
  return unwrap(response);
};

export const getTestimonialBySlug = async (slug, lang = 'en') => {
  try {
    const response = await axios.get(`${API_URL}/api/testimonials/${slug}`, { params: { lang } });
    return normalizeTestimonial(response.data?.data || null);
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};
